import { render, staticRenderFns } from "./PechatBemorData.vue?vue&type=template&id=44e83b79"
import script from "./PechatBemorData.vue?vue&type=script&lang=js"
export * from "./PechatBemorData.vue?vue&type=script&lang=js"
import style0 from "./PechatBemorData.vue?vue&type=style&index=0&id=44e83b79&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports